import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Home from './components/Home';
import Seguimiento from './components/Seguimiento';
import Solicitud from './components/Solicitud';
import Tramites from './components/Tramites';

class Router extends Component {
    render() {
        return (
            <BrowserRouter basename={"/solicitudes"}>
                <Switch>
                    <Route path="/home" component={Home} />
                    <Route path="/tramites" component={Tramites} />
                    <Route path="/solicitud/:id" component={Solicitud} />
                    <Route path="/seguimiento" component={Seguimiento} />
                    <Route path="/" component={Home} />
                </Switch>
            </BrowserRouter>
        );
    }
}

export default Router;